module.exports = __webpack_public_path__ + "img/mobile world capital.96e25e40.png";